module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-gray-aa39ea9d59b1c94c14c7723032c97dcf.png";